import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material';
import { GridCellParams } from '@mui/x-data-grid';
import { WhiteTooltip } from '@AMIEWEB/Common';
import { missingField } from 'app/constants';
import moment from 'moment';
import { isInValidTime } from '../Utils';

const StyledTootltip = makeStyles()((theme: Theme) => ({
  arrow: {
    '&:before': {
      border: '1px solid #E3DFDF',
    },
    color: theme.palette.components.tooltip.arrowColor,
  },
  truncation: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  tooltipContent: {
    backgroundColor: theme.palette.components.tooltip.backgroundColor,
    border: '1px solid #E3DFDF',
    color: theme.palette.system.errorRed,
    fontWeight: 'normal',
  },
}));

export const CustomTooltipCellRenderer = React.memo(function CustomTooltipCellRenderer(cellParams: any) {
  const { classes } = StyledTootltip();

  const getTitle = value => {
    return isInValidTime(value) ? 'Required' : '';
  };

  return (
    <WhiteTooltip
      arrow={true}
      title={getTitle(cellParams?.row?.endTime)}
      classes={{ tooltip: classes.tooltipContent, arrow: classes.arrow }}
    >
      <span style={!cellParams?.row?.endTime ? { paddingLeft: '40px' } : null} className={classes.truncation}>
        {cellParams?.row?.endTime ? ` ${moment(cellParams.row.endTime).format('hh:mm a')}` : missingField}
      </span>
    </WhiteTooltip>
  );
});

export const ErrorTooltipEndTime = (params: GridCellParams) => {
  return <CustomTooltipCellRenderer {...params} />;
};
